/** @jsxImportSource @emotion/react */
import { useEffect, useState, useContext, useRef } from "react";
import { Typography, Drawer } from "@mui/material";
import AppBar from "../../components/AppBar";
import ReebokSVG from "../../icons/reebok";
import AdidasSvg from "../../icons/adidas";
import NikeSVG from "../../icons/nike";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { IconButton } from "@mui/material";
import { UserContext } from "../../context/UserContext";
import { useGetNavItems } from "../Home/appbarNav";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { useGetRewardsScreenStyles } from "../Rewards/index.styles";
import Pagination from "../../components/Pagination";
import { Container } from "react-bootstrap";
import moment from "moment";
import { baseUrl } from "../../connections";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

import axios from "axios";

import { Document, Page } from "react-pdf/dist/esm/entry.webpack";
import BrandIconCard from "../../components/BrandIconCard";
import OfferCard from "../../components/OfferCard";
// import AppFooter from "../../components/AppFooter";
import { useFavourites } from "../../hooks/services/useFavourites";
import { Radio } from "antd";
import uuid from "react-uuid";
import { useMail } from "../../hooks/services/useMail";
import RunCounter from "../../components/RunCounter";
import Snackbar from "../../components/Snackbar";
import BackButton from "../../components/BackButton";
import { useInterval } from "../../hooks/useInterval";
import { SearchOutlined } from "@mui/icons-material";
import useGetColors from "../../utils/colors";
import { useLocation, useNavigate } from "react-router-dom";
import Footer1 from "../../components/Footer/Footer";
import { Notificationconsumer } from "../../hooks/services/notifications";

const colorsForBrands = ["#F2FCFF", "#F9FFF2", "#FFF2FB", "#FFEBDC"];
const arr = new Array(14).fill("").map((item, idx) => idx);
const brandSvgs = [NikeSVG, ReebokSVG, AdidasSvg];

const Favourites = () => {
  const navigate = useNavigate();

  const navigationView = (link) => {
    navigate(link);
  };

  const testcolor = () => {};
  const location = useLocation();

  const classes = useGetRewardsScreenStyles();
  const { userDetails } = useContext(UserContext);
  const { offerCardMultiColors: colors } = useGetColors();
  //   const [redeemedOfferIndexes, setRedeemedOfferIndexes] = useState([]);
  const {
    brandData = [],
    mailData = [],
    setFavPayload,
    setUpdateBrandFav,
    setUpdateMailFav,
    error,
  } = useFavourites();
  const options = ["Brands", "Mails"];
  const [option, setOption] = useState(options[0]);

  const {
    mailList,
    isRedeem,
    redeemMessage,
    redeemError,
    setMailPayload,
    mailHTML,
    setMailURL,
    setUpdateMailRedeem,
  } = useMail();
  const [showDrawer, setShowDrawer] = useState(false);
  const [drawerContentRoute, setDrawerContentRoute] = useState("search");
  const [offerCard, setOfferCard] = useState({});
  const [pageNUmber, setPageNumber] = useState(1);

  const isOfferContentDrawerActive = drawerContentRoute === "offerCard";

  useEffect(() => {
    if (offerCard?.type === "paid") {
      setShowDrawer(true);
    }
  }, [redeemError, isRedeem]);

  let userdata = JSON.parse(localStorage.getItem("user"));
  const { noticationdata, count, setPayloadsdata, setpage } =
    Notificationconsumer();
  useEffect(() => {
    setPayloadsdata(userdata?.uuid);
    setpage(`${pageNUmber - 1}`);
    // setStateChange(!stateChange)
  }, [pageNUmber, userdata?.uuid]);

  const NotificationUpdateseen = (notifiid) => {
    const payload = {
      notify_uuid: notifiid,
    };
    axios
      .put(`${baseUrl}/notification/update/seen`, payload, {
        headers: {
          "x-auth-token": userdata && userdata?.token,
        },
      })
      .then((res) => {
        // console.log(res)
      })
      .catch((err) => {
        // console.log(err)
      });
  };

  return (
    <div css={classes.pageContainer}>
      <AppBar navItems={useGetNavItems({}).navItems} pageTitle="Notifications" />
      <div css={classes.subWraper}>
        <div css={classes.radioGroup}></div>
      </div>
      <Container style={{ marginBottom: "30px" }}>
        {/* <Table striped hover>
                    <thead>
                        <tr>
                        <th>#</th>
                        <th>From Date</th>
                        <th>Title</th>
                        <th>Message</th>
                        </tr>
                    </thead>
                    <tbody>
                        {noticationdata?.map((item, index) => {
                            return <tr>
                                <td>{index + 1}</td>
                                <td>{moment(item.createdAt).format('YYYY-MM-DD')}</td>
                                <td>{item?.title}</td>
                                <td>{item?.message}</td>
                                </tr>   
                            }
                        )}
                    </tbody>
                </Table> */}

        <TableContainer
          component={Paper}
          sx={{
            background:
              "linear-gradient(135deg, rgba(255,255,255,0.8) 0%, rgba(255,255,255,0.65) 100%)",
            backdropFilter: "saturate(180%) blur(20px)",
            WebkitBackdropFilter: "saturate(180%) blur(20px)",
            border: "1px solid rgba(46, 125, 50, 0.1)",
            borderRadius: "16px",
            boxShadow:
              "0 4px 16px rgba(46, 125, 50, 0.06), 0 1px 3px rgba(0,0,0,0.04)",
            overflow: "hidden",
          }}
        >
          <Table
            sx={{
              minWidth: 650,
              "& .MuiTableHead-root": {
                background:
                  "linear-gradient(135deg, rgba(255,255,255,0.6) 0%, rgba(255,255,255,0.45) 100%)",
              },
              "& .MuiTableCell-head": {
                fontWeight: 600,
                fontSize: "0.85rem",
                color: "#333",
                borderBottom: "1px solid rgba(46, 125, 50, 0.1)",
                letterSpacing: "0.02em",
                padding: "14px 20px",
              },
              "& .MuiTableCell-body": {
                color: "#444",
                fontSize: "0.84rem",
                borderBottom: "1px solid rgba(46, 125, 50, 0.06)",
                padding: "12px 20px",
              },
              "& .MuiTableRow-root": {
                transition: "background-color 0.2s ease",
              },
              "& .MuiTableRow-root:hover": {
                backgroundColor: "rgba(46, 125, 50, 0.04)",
              },
              "& .MuiTableRow-root:last-child td": {
                borderBottom: "none",
              },
            }}
            aria-label="notifications table"
          >
            <TableHead>
              <TableRow>
                <TableCell>#</TableCell>
                <TableCell>From Date</TableCell>
                <TableCell>Title</TableCell>
                <TableCell>Message</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {noticationdata?.map((item, index) => (
                <TableRow
                  key={index}
                  hover
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>
                    {moment(item.createdAt).format("YYYY-MM-DD")}
                  </TableCell>
                  <TableCell>{item.title}</TableCell>
                  <TableCell>{item?.message}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Container>

      {/* <Card  style={{ paddingLeft:"20px",paddingRight:"20px" ,marginLeft:"20px",marginRight:"20px", border:"0px" }}>
            
                <Row className="g-0 h-100 align-content-left d-none d-lg-flex ps-5 pe-5 mb-2 custom-sort" >
                    <Col lg="2" className="d-flex flex-column pe-2 justify-content-center">
                        <div className="text-muted text-small cursor-pointer sort">SNO</div>
                    </Col>
                    <Col lg="2" className="d-flex flex-column pe-2 justify-content-center">
                        <div className="text-muted text-small cursor-pointer sort">From Date</div>
                    </Col>
                    <Col lg="2" className="d-flex flex-column pe-2 justify-content-center">
                        <div className="text-muted text-small cursor-pointer sort">Title</div>
                    </Col>
                    <Col lg="5" className="d-flex flex-column pe-2 justify-content-center">
                        <div className="text-muted text-small cursor-pointer sort">Message</div>
                    </Col>
                </Row>
                {noticationdata?.map((item, index) => {
                    return <Card div key="" className="mb-2" style={{ backgroundColor: item?.is_seen === true ? 'white' : '#B6B3B2' }} onClick={(event) => { navigationView(item.link); NotificationUpdateseen(item?.uuid) }}>
                        <Card.Body >
                          
                            <Row className="g-0 h-100 sh-lg-9 position-relative  mb-1" >

                                <Col xs="12" lg="2" className="d-flex flex-column justify-content-center mb-2 mb-lg-0 order-2 order-lg-2">
                                    <div className="text-muted text-small d-lg-none">Sno</div>
                                    <div className="text-alternate"  >{index + 1}</div>
                                </Col>
                                <Col xs="12" lg="2" className="d-flex flex-column justify-content-center mb-2 mb-lg-0 order-2 order-lg-2">
                                    <div className="text-muted text-small d-lg-none">date</div>
                                    <div className="text-alternate" >{moment(item.createdAt).format('YYYY-MM-DD')}</div>
                                </Col>
                                <Col xs="12" lg="2" className="d-flex flex-column justify-content-center mb-2 mb-lg-0 order-2 order-lg-2">
                                    <div className="text-muted text-small d-lg-none">Title</div>
                                    <div className="text-alternate" >{item?.title}</div>
                                </Col>
                                <Col xs="12" lg="5" className="d-flex flex-column justify-content-center mb-2 mb-lg-0 order-2 order-lg-2">
                                    <div className="text-muted text-small d-lg-none" >Message</div>
                                    <div className="text-alternate" >
                                        {item?.message}
                                    </div>
                                </Col>
                            </Row>
                           
                        </Card.Body>
                    </Card>
                })}
             
            </Card> */}

      <Footer1 />
    </div>
  );
};

export default Favourites;
